import type { ForgotPasswordDto } from '@nestjs-boilerplate/types';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

import { forgotPassword } from '../api/auth.api';

export function useForgotPassword() {
  return useMutation({
    mutationFn: (data: ForgotPasswordDto) => forgotPassword(data),
    onSuccess: (response) => {
      toast.success(response.message);
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Something went wrong. Please try again.');
    },
  });
}
